import React from 'react'
import styled from 'styled-components'
import { Fonts, CircleCheckBox } from 'components/base-ui'
import useLanguage from 'hooks/useLanguage'
import { ProductWithModifierQuery } from 'graphQL/dinein/generate/operations'
import { getRewardTotalSatangs } from 'helpers/product'
import { cloneObject, displayPriceBothNoneAnd2Digit } from 'helpers'
const placeholderProduct = `${process.env.PUBLIC_URL}/assets/placeholder-product-img.png`

interface CheckBoxPromotionProductProps {
  promotionProduct: ProductWithModifierQuery['product']['promotionProduct']
  selectedProductIDs: number[]
  onChange: (productIDs: number[]) => void
}

const CheckBoxPromotionProduct = ({
  promotionProduct,
  selectedProductIDs,
  onChange,
}: CheckBoxPromotionProductProps) => {
  const { getPropertyByLang } = useLanguage()
  const { promotion, productGroupRewards } = promotionProduct

  return (
    <Wrapper>
      <PromotionName>{getPropertyByLang({ th: promotion.nameTh, en: promotion.nameEn })}</PromotionName>
      <ProductList>
        {productGroupRewards.map((reward, i) => {
          const { rewardType, rewardValue } = reward
          const { id, nameTh, nameEn, totalPriceSatangs, images } = reward.products[0]
          const rewardTotalSatangs = getRewardTotalSatangs({ rewardType, rewardValue, totalPriceSatangs })

          const imageUrl = images.length
            ? images[0].resizableURL.replace('{width}', '168').replace('{height}', '168_fmt-jpg_fit-cover')
            : placeholderProduct

          return (
            <ProductRow key={i} onClick={() => toggleSelectProduct(id)}>
              <CheckBoxWrapper>
                <CircleCheckBox checked={selectedProductIDs.includes(id)} />
              </CheckBoxWrapper>
              <ProductThumbnail src={imageUrl} />
              <ProductName>{getPropertyByLang({ th: nameTh, en: nameEn })}</ProductName>
              <ProductPriceWrapper>
                <PriceNormal>฿{displayPriceBothNoneAnd2Digit(totalPriceSatangs / 100)}</PriceNormal>
                <PriceReward>฿{displayPriceBothNoneAnd2Digit(rewardTotalSatangs / 100)}</PriceReward>
              </ProductPriceWrapper>
            </ProductRow>
          )
        })}
      </ProductList>
    </Wrapper>
  )

  function toggleSelectProduct(productID) {
    const newSelectedProductIDs = cloneObject(selectedProductIDs)
    if (newSelectedProductIDs.includes(productID)) {
      const targetIndex = newSelectedProductIDs.indexOf(productID)
      newSelectedProductIDs.splice(targetIndex, 1)
    } else {
      newSelectedProductIDs.push(productID)
    }
    onChange(newSelectedProductIDs)
  }
}

export default CheckBoxPromotionProduct

const Wrapper = styled.div`
  position: relative;
  left: 50%;
  width: 100vw;
  transform: translateX(-50%);
  background-color: ${({ theme }) => theme.colors.bgGrayLight};
  padding: 16px;
  padding-bottom: 20px;
  z-index: 3;
`

const PromotionName = styled(Fonts.BaseTitleBold)`
  margin-bottom: 14px;
  padding: 0 12px;
  color: ${({ theme }) => theme.colors.base};
`

const ProductList = styled.div``
const ProductRow = styled.div`
  display: flex;
  align-items: center;
  border-radius: 8px;
  background-color: ${({ theme }) => theme.colors.white};
  padding: 12px 0;
  box-shadow: inset 0 0 0 1px ${({ theme }) => theme.colors.lightGrey};
`

const CheckBoxWrapper = styled.div`
  margin-left: 16px;
  margin-right: 12px;
`

const ProductThumbnail = styled.img`
  width: 56px;
  height: 56px;
  border-radius: 4px;
  background-color: ${({ theme }) => theme.colors.bgGray};
`

const ProductName = styled(Fonts.BaseTitleBold)`
  padding: 0 12px;
  color: ${({ theme }) => theme.colors.base};
`

const ProductPriceWrapper = styled.div`
  margin-left: auto;
  margin-right: 20px;
  display: flex;
  column-gap: 4px;
`

const PriceNormal = styled(Fonts.BaseTitleBold)`
  color: ${({ theme }) => theme.colors.baseGrey};
  text-decoration-line: line-through;
  white-space: nowrap;
`
const PriceReward = styled(Fonts.BaseTitleBold)`
  color: ${({ theme }) => theme.colors.primary};
  white-space: nowrap;
`
